export class GlobalCachingConfig {
    disabled?: boolean = false;
}
